import { createRoot } from 'react-dom/client'
import { isMswEnvironment } from '@/resources/utils'
import { initDatadog } from './monitoring/datadog'
import App from './App'

initDatadog()

const isPlaywrightTest = typeof window !== 'undefined' && window.PW_TEST

async function enableMocking() {
  if (!isMswEnvironment || isPlaywrightTest) {
    return
  }

  const { worker } = await import('./mocks/browser')

  return worker.start({
    onUnhandledRequest: 'bypass',
  })
}

const container = document.getElementById('app')
const root = createRoot(container)
enableMocking().then(() => root.render(<App />))
